import lazysizes from 'lazysizes';
require('lazysizes/plugins/unveilhooks/ls.unveilhooks');
import 'lazysizes/plugins/bgset/ls.bgset';

window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.lazyClass = 'js-lazyload';


// WEBPACK FOOTER //
// ./resources/js/modules/responsive-images.js